import { isExperimentalFeaturesUser } from "@/lib/experimentalFeaturesAccess";

export function isPositionFinderTabVisible(
  role: string | undefined,
  email: string | undefined,
  flag: boolean
): boolean {
  return role === "admin" && isExperimentalFeaturesUser(email) && flag;
}
